@if (chartOptions()) {
@let options = chartOptions()!;
  <div #chartContainer>
    <apx-chart
      [series]="options.series"
      [chart]="options.chart"
      [plotOptions]="options.plotOptions"
      [dataLabels]="options.dataLabels"
      [xaxis]="options.xaxis"
      [yaxis]="options.yaxis"
      [grid]="options.grid"
      [tooltip]="options.tooltip"
      [legend]="options.legend"
      [colors]="options.colors"
      [states]="options.states"
      [fill]="options.fill"
    ></apx-chart>
  </div>
}

